import { useState } from 'react';
import { Check, Copy } from 'lucide-react';
import { copyToClipboard } from '../utils/clipboard';
import { Button } from './UIComponents';

export interface CopyIconButtonProps {
  text: string;
  title?: string;
  className?: string;
}

export function CopyIconButton({ text, title = 'Copy', className = '' }: CopyIconButtonProps) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    if (!text) return;
    try {
      await copyToClipboard(text);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 1500);
    } catch {
      setCopied(false);
    }
  };

  return (
    <Button
      variant="ghost"
      size="icon"
      className={className}
      onClick={handleCopy}
      disabled={!text}
      title={copied ? 'Copied' : title}
      aria-label={copied ? 'Copied' : title}
      type="button"
    >
      {copied ? <Check className="h-5 w-5" /> : <Copy className="h-5 w-5" />}
    </Button>
  );
}
